// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "@atlaskit-internal_Tooltip" + "." + "fa81a8ea" + ".chunk.js";
};